// Generated by ts-to-zod
import {z} from "zod";
import {mantineCssStyleRecordSchema} from "./primitives.zod";

export const mantineMenuDropdownPropsSchema = z.strictObject({
	style: mantineCssStyleRecordSchema.optional(),
});
